
<div *ngIf="cageVM">
  <h4>
    Peso de Animales ({{cageVM.CageInfo}})
  </h4>

  <hr />

  <div class="row __weight">
    <div class="col-md-8 col-sm-12 mx-auto">
      <div class="form-control d-flex justify-content-between">
        <b>Peso Total:</b>
        <b>{{ totalWeight | number }} Kg</b>
      </div>
    </div>
  </div>

  <div class="row" id="inputsRow" *ngIf="animals">
  <div class="col-md-2 col-sm-6 my-2 d-flex align-items-center gap-2"
       *ngFor="let animal of animals">

    <label [for]="'peso-' + animal.AnimalInfo" class="small mb-0">
      {{ animal.AnimalInfo }}:
    </label>

    <input type="number"
           class="form-control form-control-sm"
           id="{{'peso-' + animal.AnimalInfo}}"
           [(ngModel)]="animal.Weight"
           (focusout)="setLocalWeight(animal)"
           appFocusNext
           placeholder="{{ animal.AnimalInfo }}" />

  </div>
</div>

  <hr />

  <div class="text-right">
    <button id="saveButton"
    class="btn btn-primary"
            type="button"
            (click)="save()">
      Guardar
    </button>
    <button class="btn btn-secondary"
            type="button"
            (click)="close()">
      Siguiente
    </button>
  </div>
</div>
